<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'md'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="row d-flex flex-wrap align-items-end px-3">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="input-group input-group-sm">
                    <div class="input-group-text">
                        <span style="font-size: 20px; border: none" class="input-group-text">
                            <i class="fas fa-user"></i>
                        </span>
                    </div>
                    <v-select
                        id="serviceSelect"
                        class="form-control form-control-sm"
                        label="name"
                        :options="doctor"
                        placeholder="Buscar Médico"
                        :reduce="(name) => name.id"
                        @search="mtdGetDoctor"
                        v-model="data_detail.doctor_id"
                    />
                </div>
            </div>
        </div>
   
        <template #footer>
            <button class="btn btn-success btn-sm" @click="DataDetail">
                Continuar
            </button>
        </template>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import {mapActions} from "vuex";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';

export default {
    name: "c-maintenance-modal-documento",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            doctor: [],
            data_detail: {
                doctor_id: '',
            },
            search:"",
        };
    },
    watch: {
        payload: {
        },
    },
    props: {
        title: String,
        boo_modal: Boolean,
    },
    computed: {
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdGetDoctor: function (search, loading) {
            if (search.length > 3) {
                this.doctor = [];
                loading(true);
                this.get({
                    url: this.$store.getters.get__url + "/reportPatient/mtdGetDoctor/" + search,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    this.doctor = response.data;
                    loading(false);
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
            }
        },

        mtdClose() {
            this.clear();
            this.$emit("mtdCloseModalDoc");
        },

        clear() {
            this.data_detail = {
                doctor_id: '',
            },
            this.doctor = [],
            this.search = ""
        },


        DataDetail() {
            this.$emit('Datadetail', this.data_detail.doctor_id)
            this.mtdClose();
        },
    },
    

};
</script>